import { render, staticRenderFns } from "./WordcloudDomain.vue?vue&type=template&id=6d7f63b7&scoped=true&"
import script from "./WordcloudDomain.vue?vue&type=script&lang=js&"
export * from "./WordcloudDomain.vue?vue&type=script&lang=js&"
import style0 from "./WordcloudDomain.vue?vue&type=style&index=0&id=6d7f63b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7f63b7",
  null
  
)

export default component.exports